import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showShareByEmailModal } from 'actions/modal';
import { sendInviteEmailByWAId, getWAURLEmailTemplate } from 'actions/waitingArea';
import { displayGlobalMessage } from 'actions/globalMessage';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

export default function RightPanelTop(props) {
  const dispatch = useDispatch();
  let [sendingEmail, setSendingEmail] = useState(false);
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  saveClasses =
    props.formik.errors.email || props.formik.values.email.trim() === '' || !props.emailMessageValidState.valid
      ? saveClasses + ' disabled'
      : saveClasses;

  const sendEmail = () => {
    if (
      props.formik.errors.email ||
      props.formik.values.email.trim() === '' ||
      !props.emailMessageValidState.valid ||
      sendingEmail
    ) {
      return;
    }
    let cb = (result, err) => {
      if (result) {
        setSendingEmail(false);
        dispatch(showShareByEmailModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ShareURL.EmailSuccessMsg,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      } else {
        setSendingEmail(false);
        if (err === 'InvalidRecipient') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.Errors.EmailFormatError,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err === 'AdditionalMessageNotAllowed') {
          dispatch(showShareByEmailModal(false));
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.StaffAdditionalMessageNotAllowed,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.TryAgain,
              gotItCallBack: () => {
                dispatch(
                  getWAURLEmailTemplate(props.waitingArea.id, () => {
                    dispatch(showShareByEmailModal(true));
                  })
                );
              },
            })
          );
        }
      }
    };
    setSendingEmail(true);
    let emailAddresses = props.parseEmailAddresses(props.formik.values.email);
    let payload = {
      additionalMessage: props.allowEdit ? props.additionalEmailMessage : '',
      recipients: emailAddresses.toString(),
    };
    sendInviteEmailByWAId(props.waitingArea.id, payload, cb);
  };

  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <div className="ui actions mrbl">
          <button
            tabIndex="3"
            type="button"
            data-group="updatewaitingAreaForm"
            className={sendingEmail ? saveClasses + ' loading' : saveClasses}
            onClick={sendEmail}
          >
            {APP.LANGUAGE.ShareURL.SendEmail}
            <i className="send icon" />
          </button>
          <button
            tabIndex="4"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
            onClick={() => dispatch(showShareByEmailModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="display-flex mrts mrbs pdlm pdrm">
          <button
            tabIndex="3"
            type="button"
            data-group="updatewaitingAreaForm"
            className={(sendingEmail ? saveClasses + ' loading' : saveClasses) + ' mrrm'}
            onClick={sendEmail}
          >
            {APP.LANGUAGE.ShareURL.SendEmail}
            <i className="send icon" />
          </button>
          <button
            tabIndex="4"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull"
            onClick={() => dispatch(showShareByEmailModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
    </React.Fragment>
  );
}
